import { TextArea, ButtonNext, Path } from 'components'
import { Form } from '@unform/web'
import { useContext, useRef, useEffect, useState } from 'react'
import { UserContext } from 'context/userContext'
import { dateToTimestamp } from 'helper/utils'
import { IResponse } from 'interfaces'
import useFetch from 'hooks/useFetch'
import Factory, { IObject, IListArray } from './factory'
import { Subtitles, Container, Column, Row } from './style'

const DetalhesNewCaption = ({ handleNext }: any) => {
  const { data, setData, setPage, requestFn, feedback, toggleCap } =
    useContext(UserContext)
  const [cList, setCList] = useState<IListArray>(Factory.cardList())
  const iterator = useRef(0)
  const elementList = useRef<IObject>({})
  const factory = new Factory(data)
  const api = useFetch('/')

  const handleText = (text: string, key: any) => {
    elementList.current[key] = text
    const details = Object.entries(elementList.current)
      .sort((a, b) => {
        const [ka] = a
        const [kb] = b
        return Number(ka.replace(/\D/g, '')) - Number(kb.replace(/\D/g, ''))
      })
      .map(([_, value]) => value)

    setData((cur: IObject) => ({
      ...cur,
      details,
    }))
  }

  // console.log(data)

  useEffect(() => {
    factory.indexList = [
      { name: 'CDI', aa: 10.65 },
      { name: 'SELIC', aa: 10.75 },
      { name: 'POUPANCA', aa: 10.75 },
    ]

    const c = Factory.cardList().map((card: IObject) => {
      return {
        title: card.title,
        cards: card.cards.map(([title, key]: any) => [
          title,
          key ? factory.getFormated(key) : undefined,
        ]),
      }
    })
    setCList(c)
    // console.log(data)
    // if (data?.details) {
    //   const keys = Object.entries(elementList.current)
    //   keys.forEach((k: any, i) => {
    //     elementList.current[k] = data.details[i]
    //     // handleText(data.details[i], k)
    //   })
    // }
    // console.log('listaa', elementList.current)
    // api.fetch('get').then((r: IObject) => {
    //   if (r.status !== 200) throw new Error()
    //   factory.indexList = r.data.response

    //   const c = Factory.cardList().map((card: IObject) => {
    //     return {
    //       title: card.title,
    //       cards: card.cards.map(([title, key]: any) => [
    //         title,
    //         key ? factory.getFormated(key) : null,
    //       ]),
    //     }
    //   })
    //   setCList(c)
    // })
  }, [])

  const handleSubmit = () => {
    const checkValuesConsistency = () => {
      let isConsistent = true

      data?.comission?.distribution.forEach((entry: any) => {
        entry.value.forEach((item: any) => {
          let changedFromZero = false
          let allNonZero = true

          item.values.forEach((subArray: any) => {
            const allZero = subArray.every((value: any) => value === 0)
            const allNonZeroInSubArray = subArray.every(
              (value: any) => value !== 0
            )

            if (!allZero && !allNonZeroInSubArray) {
              isConsistent = false
            }

            if (allZero && !allNonZeroInSubArray) {
              changedFromZero = true
            }

            if (!changedFromZero && !allZero && !allNonZeroInSubArray) {
              allNonZero = false
            }
          })

          if (changedFromZero && !allNonZero) {
            isConsistent = false
          }
        })
      })

      return isConsistent
    }

    if (!checkValuesConsistency()) return

    const datesForm = {
      releaseAt: dateToTimestamp(data?.releaseAt),
      startedAt: dateToTimestamp(data?.startedAt),
      tradeAt: dateToTimestamp(data?.tradeAt),
      createdAt: dateToTimestamp(data?.createdAt),
    }

    if (toggleCap === 'Proposta personalizada') {
      delete datesForm.releaseAt
    }

    const extractValues = (obj: any) => {
      if (!obj) return {}
      const extractedObj: any = {}

      Object.entries(obj).forEach(([key, value]: any) => {
        if (value === null) return
        if (typeof value === 'object' && 'value' in value) {
          extractedObj[key] = value.value
        } else {
          extractedObj[key] = value
        }
      })

      return extractedObj
    }

    let formatedData = {
      ...extractValues(data),
      ...datesForm,

      guaranteeList: data?.guaranteeList.map((v: any) => v.value),
    }
    if (data.profitabilityBonus) {
      formatedData = {
        ...formatedData,
        bonus: [
          Number(data.bonusMonths.value),
          Number(data.profitabilityBonus),
        ],
      }
    }

    const form = new FormData()

    Object.entries(formatedData).forEach(([key, value]: any) => {
      if (key === 'header') return form.append(key, value, value.name)
      if (typeof value === 'object' || Array.isArray(value))
        value = JSON.stringify(value)
      else if (!value) return
      form.append(key, value)
    })

    feedback.current = { title: 'Captação criada!', error: false }
    requestFn.current = async () => {
      try {
        const response: IResponse = await api.fetch('post', form, '/token', {
          'Content-type': 'multipart/form-data',
        })

        return response
      } catch (err: any) {
        console.error('err', err)
        return err
      }
    }
    setPage((prev) => prev + 2)
  }

  return (
    <Container>
      <Path className="path">
        <span className="path">
          {
            'Gestão de produtos >  Investimentos  > Nova captação  > Layout > Detalhes da nova captação'
          }
        </span>
      </Path>
      <h1 className="detalhes-nova-cap-title">
        Texto de Detalhes da Nova captação
      </h1>
      <Form onSubmit={handleNext} data-testid="form-new-caption">
        <Column>
          {cList.map((card: any, i: number) => {
            const { title, cards } = card
            iterator.current = 0
            return (
              <div key={`sub_${i}`}>
                <Subtitles>{title}</Subtitles>
                {new Array(Math.ceil(cards.length / 3))
                  .fill(null)
                  .map((_, j) => (
                    <Row key={`row_${i}${j}`}>
                      {new Array(3).fill(null).map(() => {
                        const cardin = cards[(iterator.current += 1)]
                        const key = `card_${i}_${j}_${iterator.current}`
                        if (cardin) {
                          elementList.current[key] =
                            elementList.current[key] || null
                          return (
                            <TextArea
                              key={key}
                              onChange={(text: string) => handleText(text, key)}
                              title={cardin[0]}
                              tag={cardin[1]}
                              // value={data?.details[position]}
                              value={elementList.current[key]}
                              style={{ marginTop: 16 }}
                            />
                          )
                        }
                        return (
                          <div key={`empty_${i}_${j}_${iterator.current}}`} />
                        )
                      })}
                    </Row>
                  ))}
              </div>
            )
          })}
        </Column>
        <ButtonNext
          isAdvance
          advancePage={() => handleSubmit()}
          isBack
          backPage={() => setPage((prev) => prev - 1)}
          // backPage={backTablePage}
        />
      </Form>
    </Container>
  )
}

export default DetalhesNewCaption
